<template>
  <span
    class="hamburger-menu-icon"
    title="Menu"
    aria-expanded="false"
    data-bs-toggle="dropdown"
    data-bs-auto-close="true"
  >
    <span :class="[{ active: isActive }]" @click="toggleHamburguerMenu"> <i></i><i></i><i></i> </span>
  </span>
</template>
<script lang="ts" setup>
import { onMounted, onUnmounted, ref } from "vue";

const isActive = ref(false);

const toggleHamburguerMenu = (): void => {
  isActive.value = !isActive.value;
};

onMounted(() => {
  document.addEventListener("click", handleOutsideClick);
});

onUnmounted(() => {
  document.removeEventListener("click", handleOutsideClick);
});

const handleOutsideClick = (event: Event): void => {
  const hamburgerMenu = document.querySelector(".hamburger-menu-icon");
  if (hamburgerMenu && !hamburgerMenu.contains(event.target as Node)) {
    isActive.value = false;
  }
};
</script>
<style scoped>
.hamburger-menu-icon {
  background-color: white;
  color: blue;
  border-radius: 0.2rem;
  font-size: 1.5em;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1.2rem 1.1rem;
  scale: 0.8;
}

h4 {
  text-align: center;
}
</style>
<style lang="scss" scoped>
$animation-speed: 0.5s;
$bars-color: blue;
span {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 1.8rem;
  height: 1.3rem;
  cursor: pointer;

  i {
    background-color: $bars-color;
    border-radius: 3px;
    content: "";
    display: block;
    width: 100%;
    height: 0.25rem;
  }

  i:nth-child(1) {
    -webkit-animation: outT $animation-speed backwards;
    animation: exitSingleLine $animation-speed backwards;
    -webkit-animation-direction: reverse;
    animation-direction: reverse;
  }

  i:nth-child(2) {
    margin: 5px 0;
    -webkit-animation: outM $animation-speed backwards;
    animation: closeToHamburger $animation-speed backwards;
    -webkit-animation-direction: reverse;
    animation-direction: reverse;
  }
  i:nth-child(3) {
    -webkit-animation: outBtm $animation-speed backwards;
    animation: lineToHamburger $animation-speed backwards;
    -webkit-animation-direction: reverse;
    animation-direction: reverse;
  }

  &.active {
    i:nth-child(1) {
      -webkit-animation: inT $animation-speed forwards;
      animation: enterSingleLine $animation-speed forwards;
    }
    i:nth-child(2) {
      -webkit-animation: inM $animation-speed forwards;
      animation: hamburgerToClose $animation-speed forwards;
    }
    i:nth-child(3) {
      -webkit-animation: inBtm $animation-speed forwards;
      animation: hamburgerToLine $animation-speed forwards;
    }
  }
}

@keyframes hamburgerToClose {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes closeToHamburger {
  50% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(45deg);
  }
}

@keyframes enterSingleLine {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes exitSingleLine {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(9px) rotate(0deg);
  }
  100% {
    transform: translateY(9px) rotate(135deg);
  }
}

@keyframes hamburgerToLine {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}

@keyframes lineToHamburger {
  0% {
    transform: translateY(0px) rotate(0deg);
  }
  50% {
    transform: translateY(-9px) rotate(0deg);
  }
  100% {
    transform: translateY(-9px) rotate(135deg);
  }
}
</style>
